import React from "react"
import PropTypes from "prop-types"

const VideoPlay = ({ fillColor }) => (
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="36.85" cy="36.85" r="36.85" fill="white" />
    <path
      d="M29.9447 49.8289V24.4968L47.4823 37.1628L29.9447 49.8289Z"
      fill={fillColor}
    />
  </svg>
)

VideoPlay.propsTypes = {
  fillColor: PropTypes.string,
}

VideoPlay.defaultProps = {
  fillColor: "var(--page-color)",
}

export { VideoPlay }
